//document ready
$(function() {

  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  
    searchAutocomplete.init();
  
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();


  productPage.initializeQuantityBox();
  productPage.init();
  productPage.relatedProducts();

  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 798) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });

  

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  
    newsletter_popup.init();
  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  

  //Terms of service settings for minicart
  

  
      $('body').on('click', ".cart_content .action_button", function(e) {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = "/cart";
      });
    


  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
    enableLoadMoreProducts();
  

  

  

  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

  ajaxRefreshCart = () => {
    $.ajax({
      url: '/cart.js',
      dataType: "json",
      cache: false,
      success: function(cart) {
        refreshCart(cart);
        if($('body').hasClass('fancybox-active')) {
          $.fancybox.close();
        }

        if($('#header').is(':visible')) {
          $('#header .cart_container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart_container').addClass('active_link');
        } else {
          $('.top_bar .cart_container').addClass('active_link');
        }

        NProgress.done();

        //block scrolling on mobile
        if ($(window).width() <= 798) {
          var $cart_container = $(this).parent();
          if($cart_container.hasClass('active_link')) {
            $('body').addClass('blocked-scroll');
          } else {
            $('body').addClass('blocked-scroll');
          }
        }
      }
    });
  }

  function refreshCart(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var _isBundleMain = false;
        var _isComboBack = false;

        var line_id = index + 1;
        cart_items_html += '<li class="cart_item clearfix">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (title == 'bundle') {
              _isBundleMain = true;
            }
            if (title == 'combo' && value == 'yes') {
              _isComboBack = true;
            }
            if (value && title != "bundle") {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }
        cart_items_html += '</div></a>';

        
          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            url: "/products/" + item.handle + ".js",
            success: function(data) {
              var variant_id = item.variant_id;
              var variant = $.grep(data.variants, function(v) {
                return v.id == variant_id;
              });

              var _c = '';
              var _ht = '';
              if (data.tags.includes('addons') || _isComboBack || _isBundleMain) {
                _c = 'hide ';

                if (_isBundleMain) {
                  console.log(item);
                  var _bundle = '<a data-id="'+item.id+'" onclick="removeProduct(this)" data-bundleid="'+item.properties['bundle']+'" style="color: white !important;" class="button color-white">Remove</a><br>'
                  _ht = '<div class="left product-quantity-box">'+_bundle+'Quantity x'+item.quantity+'</div>'
                }
                else{
                  _ht = '<div class="left product-quantity-box">Quantity x'+item.quantity+'</div>'
                }

              }

              cart_items_html += '<div class="'+_c+' left product-quantity-box">' +
                  '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
                  '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
                  '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
                '</div>' + _ht +
              '</div>';

              cart_items_html += '<strong class="right price">';

              if(variant[0] && variant[0].compare_at_price > item.price) {
                cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                discounted_price_total += item.price * item.quantity;
                total_savings += variant[0].compare_at_price * item.quantity;
              }
            }
          });
        

        cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong>' + '</div>';

      });

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' +
          '<span>Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
            '<span>Total Savings</span>';
      } else {
        cart_savings_html = "";
      }
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

    
  }

  $('body').on("change", "#cart_form input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

  $('input[name="trapo_fix"]').click(function() {
     $('input[name="trapo_fix"]').not(this).prop("checked", false);
  });


  $('#trapo_back').change(function() {
      if(this.checked) {
         var mainPrice1 = $(".omega .customise_money").data("price");
        var mainPriceS1 = $(".omega .current_price.discounted_money").data("sprice");
        var trapoBackPrice = $(this).data("price");
        var trapoBackSPrice = $(this).data("discounted");
        var totalPrice1 = mainPrice1 + trapoBackPrice;
        var totalPriceS1 = mainPriceS1 + trapoBackSPrice;
        console.log(trapoBackSPrice);
        console.log(totalPriceS1);
       
        $(".omega .color-pink.customise_money").removeData('price');
        $(".omega .current_price.discounted_money").removeData('sprice');
        $(".omega .customise_money").attr("data-price",totalPrice1);
        $(".omega .current_price.discounted_money").attr("data-sprice",totalPriceS1);
          var totalPriceFormat = Shopify.formatMoney(totalPrice1, $("body").data("money-format"));
        var totalPriceFormatS1 = Shopify.formatMoney(totalPriceS1, $("body").data("money-format"));
          $(".customise_money .money").text(totalPriceFormat);
        $(".current_price.discounted_money .money").text(totalPriceFormatS1);
      } else{
        var mainPrice2 = $(".omega .customise_money").data("price");
        var mainPriceS2 = $(".omega .current_price.discounted_money").data("sprice");
        var trapoBackPrice = $(this).data("price");
         var trapoBackSPrice = $(this).data("discounted");
        var totalPrice2 = mainPrice2 - trapoBackPrice;
        var totalPriceS2 = mainPriceS2 - trapoBackSPrice;
        
        $(".omega .color-pink.customise_money").removeData('price');
         $(".omega .current_price.discounted_money").removeData('sprice');
        $(".omega .customise_money").attr("data-price",totalPrice2);
        $(".omega .current_price.discounted_money").attr("data-sprice",totalPriceS2);
        var mainPriceFormat = Shopify.formatMoney(totalPrice2, $("body").data("money-format"));
        var mainPriceFormatS = Shopify.formatMoney(totalPriceS2, $("body").data("money-format"));
        $(".customise_money .money").text(mainPriceFormat);
        $(".current_price.discounted_money .money").text(mainPriceFormatS);
      }
    });
  
  
  $('#trapo_hex').change(function() {
      if(this.checked) {
         var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         var trapoHexPrice = $(this).data("discounted");
         var trapoHexDisPrice = $(this).data("price");
        
        var totalMainPrice = mainPrice + trapoHexPrice;
        var totalMainDisPrice = mainDisPrice + trapoHexDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat); 
      } else{
        var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
        var totalMainPriceFormat = Shopify.formatMoney(mainPrice, $("body").data("money-format"));
        var totalDisPriceFormat = Shopify.formatMoney(mainDisPrice, $("body").data("money-format"));
        $(".customise_money .money").text(totalDisPriceFormat);
        $(".current_price.discounted_money .money").text(totalMainPriceFormat);
      }
    });
  
  $('#trapo_eco').change(function() {
      if(this.checked) {
        var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         var trapoEcoPrice = $(this).data("discounted");
         var trapoEcoDisPrice = $(this).data("price");
        
        var totalMainPrice = mainPrice + trapoEcoPrice;
        var totalMainDisPrice = mainDisPrice + trapoEcoDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat);    
      } else{
         var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
        var totalMainPriceFormat = Shopify.formatMoney(mainPrice, $("body").data("money-format"));
        var totalDisPriceFormat = Shopify.formatMoney(mainDisPrice, $("body").data("money-format"));
        $(".customise_money .money").text(totalDisPriceFormat);
        $(".current_price.discounted_money .money").text(totalMainPriceFormat);
      }
    });
  
  $('input[name="trapo_fix"]').change(function() {
      if(this.checked) {
         var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         var trapoFixPrice = $(this).data("price");
         var trapoFixDisPrice = $(this).data("disprice");
        
        var totalMainPrice = mainPrice + trapoFixPrice;
        var totalMainDisPrice = mainDisPrice + trapoFixDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat);       
      } else{
          var mainPrice = $(".omega .current_price.discounted_money").data("sprice");
         var mainDisPrice = $(".omega .current_price.discounted_money").data("mainprice");
         
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
        var totalMainPriceFormat = Shopify.formatMoney(mainPrice, $("body").data("money-format"));
        var totalDisPriceFormat = Shopify.formatMoney(mainDisPrice, $("body").data("money-format"));
        $(".customise_money .money").text(totalDisPriceFormat);
        $(".current_price.discounted_money .money").text(totalMainPriceFormat);
      }
    });

  
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      var formData = $addToCartForm.serialize();
      //.log($addToCartForm.serialize());
      //formData.push({ name: "id", value: "39519064227917" });
      
      //console.log(formData);
      
      if($('#trapo_back').prop("checked") == true){
        
        var option0 = $('input[name="option-0"]:checked').val().toLowerCase();
        var option1 = $('input[name="option-2"]:checked').val().toLowerCase();
        var variantOption = option0+"-"+option1;
        console.log(variantOption);
        var selectedVariant = $("." + variantOption).val();
        
       $.ajax({
          type: "POST",
         dataType: 'json',
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: selectedVariant,
            	"properties" : {
                  "combo": "yes"
                }
            },
          async: false
        }); 
       //var bootVariant = '&id='+selectedVariant+'&quantity=1';
       //formData+='&id='+selectedVariant+'&quantity=1';
        
        var mainSelVariant = $('.multi_select').val();
      	var mainVariantQty = $('#quantity').val();
        var mainVariantPrice = $('.omega .current_price.customise_money .money').text(); 
        console.log(mainVariantPrice);
        formData = {
                quantity: mainVariantQty,
                id: mainSelVariant,
          		"properties" : {
                  "Bundle Product": "Trapo Back",
				  "Final Price": mainVariantPrice,
				  "TrapoBackID": selectedVariant,
				  "Trapo Fix Price": 0,
				  "Warranty Price": 0,
				  "bundle": ""
                }
              }
      }
      
      
      if($('#trapo_hex').prop("checked") == true){
        
      
        var selectedHexVariant = $("#trapo_hex:checked").attr("data-id");
        console.log(selectedHexVariant);
        
       $.ajax({
          type: "POST",
         dataType: 'json',
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: selectedHexVariant
            },
          async: false
        }); 
       //var bootVariant = '&id='+selectedVariant+'&quantity=1';
       //formData+='&id='+selectedVariant+'&quantity=1';
        
        var mainSelVariant = $('.multi_select').val();
      	var mainVariantQty = $('#quantity').val();
        var mainVariantPrice = $('.omega .current_price.customise_money .money').text(); 
        console.log(mainVariantPrice);
        formData = {
                quantity: mainVariantQty,
                id: mainSelVariant,
          		"properties" : {
                  "Bundle Product": "Classic Plus",
				  "Final Price": mainVariantPrice,
				  "TrapoBackID": "",
				  "Trapo Fix Price": 0,
				  "Warranty Price": 0,
				  "bundle": selectedHexVariant
                }
              }
      }
      
      if($('#trapo_eco').prop("checked") == true){
        
      
        var selectedEcoVariant = $("#trapo_eco:checked").attr("data-id");
        console.log(selectedHexVariant);
        
       $.ajax({
          type: "POST",
         dataType: 'json',
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: selectedEcoVariant
            },
          async: false
        }); 
       //var bootVariant = '&id='+selectedVariant+'&quantity=1';
       //formData+='&id='+selectedVariant+'&quantity=1';
        
        var mainSelVariant = $('.multi_select').val();
      	var mainVariantQty = $('#quantity').val();
        var mainVariantPrice = $('.omega .current_price.customise_money .money').text(); 
        console.log(mainVariantPrice);
        formData = {
                quantity: mainVariantQty,
                id: mainSelVariant,
          		"properties" : {
                  "Bundle Product": "Classic Plus",
				  "Final Price": mainVariantPrice,
				  "TrapoBackID": "",
				  "Trapo Fix Price": 0,
				  "Warranty Price": 0,
				  "bundle": selectedEcoVariant
                }
              }
      }
      
      $('input[name="trapo_fix"]').each(function() {
      //if($('input[name="trapo_fix"]').prop("checked") == true){
        if ($(this).prop('checked')==true){ 
        var selectedFixVariant = $('input[name="trapo_fix"]:checked').attr("data-id");
        var selectedFixPrice = $('input[name="trapo_fix"]:checked').attr("data-pricing");
        console.log(selectedFixVariant);
        
        
        $.ajax({
          type: "POST",
         dataType: 'json',
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: selectedFixVariant
            },
          async: false
        }); 
       //var bootVariant = '&id='+selectedVariant+'&quantity=1';
       //formData+='&id='+selectedVariant+'&quantity=1';
        
        var mainSelVariant = $('.multi_select').val();
      	var mainVariantQty = $('#quantity').val();
        var mainVariantPrice = $('.omega .current_price.customise_money .money').text(); 
        console.log(mainVariantPrice);
        formData = {
                quantity: mainVariantQty,
                id: mainSelVariant,
          		"properties" : {
                  "Bundle Product": "Trapo Fix",
				  "Final Price": mainVariantPrice,
				  "TrapoBackID": "",
				  "Trapo Fix Price": selectedFixPrice,
				  "Warranty Price": 0,
				  "bundle": selectedFixVariant
                }
              }
      }
      }); 
      
      console.log(formData);
      if ($('div').hasClass("product-extra-field")) {
      var _email = $('#product_customer_email').val();
      var _name = $('#product_customer_name').val();
      var _phone = $('#product_customer_phone').val();
    
      // console.log(_email, _name, _phone);
      _phone.length == 0 || _name.length == 0 ? $('.email_error').show() : $('.email_error').hide() ;
    
      _email.includes('@') && _email.includes('.com') ? $('.special_email_error').hide() : $('.special_email_error').show() ;
    
      var iscontain =  _name.length > 0 && _phone.length > 0 && _email.includes('@') && _email.includes('.com') ? true : false ;
      }
      else{
       var iscontain = true;
      }

      console.log(iscontain);
        if (iscontain) {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: formData,
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              Shopify.getCart(function(cart) {
                  refreshCart(cart);
                });
              if($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }

              if($('#header').is(':visible')) {
                $('#header .cart_container').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart_container').addClass('active_link');
              } else {
                $('.top_bar .cart_container').addClass('active_link');
              }

              //block scrolling on mobile
              if ($(window).width() <= 798) {
                var $cart_container = $(this).parent();
                if($cart_container.hasClass('active_link')) {
                  $('body').addClass('blocked-scroll');
                } else {
                  $('body').addClass('blocked-scroll');
                }
              }
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });
      }

      return false;
    });
  

  productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
        if($('#shopify-product-reviews').length >= 1) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    
      newsletter_popup.init();
    

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    
      if ($parentSection.hasClass('search-section')){
        searchAutocomplete.init();
      }
    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
        if($('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.productSwatches();
      productPage.relatedProducts();
      recentlyViewed.init();
      
        if($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
        searchAutocomplete.init();
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


 
$('input[name="trapo_fix"]').click(function() {
   $('input[name="trapo_fix"]').not(this).prop("checked", false);
});

 $(window).on('load', function(){
if ($('.swatch > div.option_title:contains("Bagian Karpet")').length > 0) {
      $(".swatch_options .swatch[data-option-index='0'] .option_title").empty();
        $(".swatch_options .swatch[data-option-index='0'] .option_title").append("Warna Dasar");
      $(".swatch_options .swatch[data-option-index='1'] .option_title").empty();
        $(".swatch_options .swatch[data-option-index='1'] .option_title").append("Warna Lining");
      $("<div class='new-steps'><span class='new-step-2'>Step 1</span></div>").insertBefore(".swatch_options");
      $("<p class='txt-choose-cmb'>Pilih kombinasi warna Anda</p>").insertBefore(".swatch_options > div.swatch:nth-child(1)");
      $("<div class='new-steps'><span class='new-step-2'>Step 2</span></div>").insertBefore("[data-option-index='2']");
      $("<p class='txt-choose-pkg'>Pilih paket karpet mobil Anda</p>").insertBefore("[data-option-index='2'] > .option_title");
      $("<div class='new-steps new-steps-3'><span class='new-step-3'>Step 3</span></div>").insertAfter(".swatch_options");
      // Package options Label
      $("<p class='new-label' style='height: 110px'>All Included<br><span style='font-family:effrabold !important;color:#ee2a7b'>(Save 30%)</span></p>").insertAfter(".swatch_options [data-value='All Included'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Baris 1 & 2</p>").insertAfter(".swatch_options [data-value='Baris 1 & 2'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Driver + Passenger</p>").insertAfter(".swatch_options [data-value='Driver + Passenger'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Pengemudi Saja</p>").insertAfter(".swatch_options [data-value='Pengemudi Saja'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Bagasi Saja</p>").insertAfter(".swatch_options [data-value='Bagasi Saja'] > label.b-rad-50");
      $("<p class='new-label' style='width:100px;height: 110px'>Full Set</p>").insertAfter(".swatch_options [data-value='Full Set'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Sidestep</p>").insertAfter(".swatch_options [data-value='Sidestep'] > label.b-rad-50");
      $("<p class='new-label' style='height: 110px'>Baris 1 & 2 & 3</p>").insertAfter(".swatch_options [data-value='Baris 1 & 2 & 3'] > label.b-rad-50");
      $("<p class='new-label' style='height: 125px'>Full Set + Extra Bagasi<br><span style='color:#ee2a7b;font-size: 0.65rem;''>(Save 40%)</span></p>").insertAfter(".swatch_options [data-value='Full Set + Extra Bagasi'] > label.b-rad-50");

        }
      });

$('.trans-swatch label').click(function() {
     $('.trans-swatch label').removeClass('active');
    $(this).addClass('active');
  });